import {getContactData, editContactData, checkIdentifyCode} from '@api/base/index.js';

export const getContactInfo = (params) => {
    return getContactData(params).then(res => {
        return res.data;
    })
}

export const editContactInfo = (params) => {
    return editContactData(params).then(res => {
        return res;
    })
}

export const checkVerifyCode = (params) => {
    return checkIdentifyCode(params).then((res) => {
        if (res.result === 1) {
            return true;
        }
        return false;
    })
}